









export default
	props:
		logos: Array


